import { authClient, operatorClient, onboardingClient } from 'domain/HttpClients';

export const checkCompanyCode = async (companyCode) => {
  const resp = operatorClient
    .Get(`/public-api/company/token/${encodeURIComponent(companyCode)}/validate`)
    .send();

  return resp;
};

export const createUser = async ({ userInfo, type, headers }) => authClient
  .Post('/api/self')
  .withData({ ...userInfo, accountType: type })
  .withHeaders(headers)
  .send();

export const createAccount = async ({ accountInfo, type, headers }) => authClient
  .Post('/api/self/accounts')
  .withData({ ...accountInfo, accountType: type })
  .withHeaders(headers)
  .send();

export const signIn = async (data) => {
  const resp = await authClient
    .Post('/public-api/user-admin/signin')
    .withData(data)
    .send();

  return resp;
};
